import { Chip, Link } from '@mui/material';
import { Datagrid, List, TextField, DateField, FunctionField } from 'react-admin';
import { Webhook } from '../../types/webhooks';

const StatusChip = ({ record }: { record: Webhook }) => {
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'active':
        return 'success';
      case 'failed':
        return 'error';
      default:
        return 'default';
    }
  };

  return <Chip label={record.status} color={getStatusColor(record.status)} size="small" variant="outlined" />;
};

const WebhooksList: React.FC = () => {
  return (
    <List exporter={false} title="Webhooks">
      <Datagrid optimized bulkActionButtons={false} rowClick="show">
        <TextField source="uuid" label="UUID" />
        <FunctionField
          label="Webhook URL"
          render={(record: Record<string, any>) =>
            record?.webhookUrl ? (
              <Link href={record.webhookUrl} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
                {record.webhookUrl}
              </Link>
            ) : null
          }
        />
        <FunctionField label="Events" render={(record: Record<string, any>) => (record?.eventTypes && Array.isArray(record.eventTypes) ? record.eventTypes.join(', ') : null)} />
        <TextField source="companyName" label="Company" />
        <TextField source="partnerName" label="Partner" />
        <DateField source="createdAt" label="Created At" showTime />
        <DateField source="updatedAt" label="Updated At" showTime />
        <FunctionField label="Status" render={(record: Record<string, any>) => (record ? <StatusChip record={record as Webhook} /> : null)} />
      </Datagrid>
    </List>
  );
};

export default WebhooksList;
